import styled from 'styled-components';
import { Spacing } from '../obj.constants';

export const Icon = styled.img`
  width: ${Spacing.Large}px;
`;
